import { createAction, props } from '@ngrx/store';
import { GeoLocationResponse } from '../../models/core-apis/geo-location.interfaces';

enum GeoLocationActionTypes {
  storeGeoLocationInputValues = '[flight-shop book widget] geo location store input values',
  loadGeoLocation = '[flight-shop book widget] load geo location',
  loadGeoLocationSuccess = '[flight-shop book widget] load geo location success',
  loadGeoLocationFailure = '[flight-shop book widget] load geo location failure'
}

export const LoadGeoLocation = createAction(
  GeoLocationActionTypes.loadGeoLocation
);

export const LoadGeoLocationSuccess = createAction(
  GeoLocationActionTypes.loadGeoLocationSuccess,
  props<{ geoLocationData: GeoLocationResponse }>()
);

export const LoadGeoLocationFailure = createAction(
  GeoLocationActionTypes.loadGeoLocationFailure
);

export const StoreGeoLocationInputValues = createAction(
  GeoLocationActionTypes.storeGeoLocationInputValues,
  props<{ skipGeoLocationApi: boolean }>()
);
